/** Rotation hebdomadaire simplifiée du raid Gigamax mis en avant. */

export function getUtcWeekIndex(date: Date = new Date()): number {
  const start = Date.UTC(date.getUTCFullYear(), 0, 1)
  const dayOfYear = Math.floor((Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()) - start) / 86_400_000)
  return Math.floor(dayOfYear / 7)
}

export function getFeaturedGmaxRaidSlug(
  raidSlugs: readonly string[],
  date: Date = new Date(),
): string {
  if (!raidSlugs.length) return ''
  const index = getUtcWeekIndex(date) % raidSlugs.length
  return raidSlugs[index] ?? ''
}

export function isFeaturedGmaxRaidSlug(
  slug: string,
  raidSlugs: readonly string[],
  date: Date = new Date(),
): boolean {
  if (!slug) return false
  return slug === getFeaturedGmaxRaidSlug(raidSlugs, date)
}
